import { Dimension, Quantity } from "dimtext";

function nextIndex(i, direction) {
  return direction === "forward" ? i + 1 : i - 1;
}

function modifyDimString(values, index, newValue, unit) {
  if (!values.length) return [];

  if (values.length === 1) {
    values[0].value = newValue;
    return values;
  }

  const nums = values.map((v) => v.value.toNumber(unit));
  const newNum = newValue.toNumber(unit);

  let searching = index < values.length - 1 ? "forward" : "backward";
  const max = nums.reduce((a, b) => a + b, 0);
  const num = Math.max(Math.min(newNum, max), 0);
  values[index].value =
    newNum === num ? newValue : new Dimension(new Quantity(num, unit));
  values[index].keyed = true;
  let diff = num - nums[index];
  if (diff < 0) {
    const a = values.findIndex((v, vi) => vi > index && !v.keyed);
    const b = values.findLastIndex((v, vi) => vi < index && !v.keyed);
    const ak = values.findIndex((v, vi) => vi > index && v.keyed);
    const bk = values.findLastIndex((v, vi) => vi < index && v.keyed);
    const indices = searching === "backward" ? [b, a, bk, ak] : [a, b, ak, bk];
    const i = indices.find((i) => i !== -1);
    if (i !== -1) {
      values[i].value = new Dimension(new Quantity(nums[i] - diff, unit));
    }
  } else {
    let i = searching === "forward" ? index + 1 : index - 1;
    let keyed = false;
    let searched = false;
    while (diff > 0) {
      const oob = searching === "forward" ? i >= values.length : i < 0;
      if (oob) {
        if (keyed && searched) break;
        if (keyed) {
          keyed = false;
          searching = searching === "forward" ? "backward" : "forward";
          searched = true;
          i = nextIndex(index, searching);
          continue;
        }
        i = nextIndex(index, searching);
        keyed = true;
        continue;
      } else if (values[i].keyed && !keyed) {
        i = nextIndex(i, searching);
        continue;
      }

      const next = Math.max(nums[i] - diff, 0);
      diff -= nums[i] - next;
      values[i].value = new Dimension(new Quantity(next, unit));
      nums[i] = next;
      i = nextIndex(i, searching);
    }
  }

  return values;
}

export default modifyDimString;
